import type { JSX } from 'react';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PetitionGammaCommonProps } from '../../shared/types';

import { CommonPetitionDetails } from './CommonPetitionDetails';

/**
 * This entry point is rendered by the the Old Petition page's sub-route rendering. This is the main entry point for
 * human on the main `/p/:slug` route when Gamma is enabled. Because it is for human users, it doesn't have the context
 * wrapping that bot-share-routes do.
 */
export const PetitionGammaDetails = withPrefetchedData(
	function PetitionGammaDetails({ userInfoState }: PetitionGammaCommonProps): JSX.Element {
		return <CommonPetitionDetails userInfoState={userInfoState} />;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [CommonPetitionDetails],
	},
);
